export const HITLAB_INTAKE_PATH = '/hitlab/intake';
export const HITLAB_SUBMIT_PATH = '/hitlab/submit';
export const HITLAB_SESSION_MESSAGE =
  'Please sign in again to continue your artist intake.';

const HITLAB_ATTRIBUTION_KEYS = ['src', 'campaign', 'ref'];

export function isHitLabClientEnabled(
  value = process.env.REACT_APP_HITLAB_ARTIST_INTAKE_ENABLED,
) {
  const normalized = String(value || '').trim().toLowerCase();
  return !['0', 'false', 'off', 'disabled'].includes(normalized);
}

export function getHitLabAttribution(search = '') {
  const params = new URLSearchParams(search || '');
  return HITLAB_ATTRIBUTION_KEYS.reduce((acc, key) => {
    const value = String(params.get(key) || '').trim().slice(0, 80);
    if (value) acc[key] = value;
    return acc;
  }, {});
}

export function buildHitLabIntakeReturnTo(search = '') {
  const attribution = getHitLabAttribution(search);
  const params = new URLSearchParams();
  Object.entries(attribution).forEach(([key, value]) => params.set(key, value));
  const query = params.toString();
  return query ? `${HITLAB_INTAKE_PATH}?${query}` : HITLAB_INTAKE_PATH;
}

export function buildHitLabLoginPath(search = '') {
  return `/login?returnTo=${encodeURIComponent(buildHitLabIntakeReturnTo(search))}`;
}

export function getApiMessage(error, fallback) {
  return error?.response?.data?.message || fallback;
}

export function isHitLabUnauthorizedError(error) {
  return Number(error?.response?.status) === 401;
}

export function getHitLabApiMessage(error, fallback) {
  if (isHitLabUnauthorizedError(error)) return HITLAB_SESSION_MESSAGE;
  return getApiMessage(error, fallback);
}

export function buildHitLabAuthConfig(player) {
  const token = String(player?.token || '').trim();
  if (!token) return null;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export function isHttpsUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return false;
  try {
    return new URL(raw).protocol === 'https:';
  } catch (err) {
    return false;
  }
}

export function isHttpsSongUrl(value) {
  return isHttpsUrl(value);
}
